import { Box, Container } from "@mui/material";
import React from "react";

import Login from "../../components/Login/Login";

export default function Home({ theme }) {
    const containerStyle = { ...theme.container };
    containerStyle.backgroundColor = theme.palette.background.mainPalette;
    return (
        <>
            <Container sx={containerStyle}>
                <Box
                    display={"flex"}
                    justifyContent={"center"}
                    alignItems={"center"}
                    sx={{ height: "100vh" }}
                >
                    <Login />
                </Box>
            </Container>
        </>
    );
}
